import { showHeaderOverlay, hideHeaderOverlay } from '../tools/overlay'
import { checkResolution } from '../tools/helpers'
import './tabs'
import './navigation-menu-aim'

const navigationEl = document.querySelector('.js-navigation')

const handleClickOutside = (event) => {
    if (
        !checkResolution('lg')
        && !navigationEl.contains(event.target)
        && !aside.trigger.contains(event.target)
    ) {
        aside.close()
    }
}

const aside = {
    trigger: document.querySelector('.js-aside-trigger'),
    target: navigationEl,
    toggle() {
        if (this.trigger.classList.contains('is-active')) {
            this.close()
        } else {
            this.open()
        }
    },
    open() {
        this.trigger.classList.add('is-active')
        this.target.classList.add('is-active')
        showHeaderOverlay('nav-aside')
        document.addEventListener('click', handleClickOutside)
    },
    close() {
        this.trigger.classList.remove('is-active')
        this.target.classList.remove('is-active')
        this.target.closeAllTabs()
        hideHeaderOverlay('nav-aside')
        document.removeEventListener('click', handleClickOutside)
    }
}

if (aside.trigger) {
    aside.trigger.addEventListener('click', event => {
        aside.toggle()
    })
}

function handleTopProductsAutoplay(event) {
    for (const tabEl of event.detail.targets) {
        const topProductsSliderEl = tabEl.querySelector('[r-slider-top-products]')
        if (!topProductsSliderEl) continue

        const swiperAutoplay = topProductsSliderEl?.swiper?.autoplay
        if (!swiperAutoplay) continue

        const isTabActive = event.detail.activeTabs.includes(tabEl.id)

        if (isTabActive) {
            swiperAutoplay.start()
        } else {
            swiperAutoplay.stop()
        }
    }
}

if (document.querySelector('[r-slider-top-products]')) {
    navigationEl.addEventListener('rTab.after.closeAllTabs', handleTopProductsAutoplay)
    navigationEl.addEventListener('rTab.after.closeTab', handleTopProductsAutoplay)
    navigationEl.addEventListener('rTab.after.openTab', handleTopProductsAutoplay)
    navigationEl.addEventListener('rTab.after.openTab', (event) => {
        const tabEl = event.detail.getTarget(event.detail.activeTabs[0])
        if (!tabEl) return

        const topProductsSliderEl = tabEl.querySelector('[r-slider-top-products]')
        if (!topProductsSliderEl) return

        const swiper = topProductsSliderEl.swiper
        if (!swiper) return

        setTimeout(() => {
            swiper.update();
        }, 50);
    })
}